export default function Heading1({ text }) {
  return <div className="theme-text-heading-1 font-semibold">{text}</div>;
}
